import withDrawerState, { WithDrawerProps } from 'enhancers/withDrawerState';
import * as React from 'react';
import {
  NavLink as Link,
  RouteComponentProps,
  withRouter
} from 'react-router-dom';
import styled from 'styled-components';

interface IProps {
  children: React.ReactNode;
  to: string;
  exact?: boolean;
  margin?: string;
  className?: string;
}

type Props = IProps & WithDrawerProps & RouteComponentProps<any>;

const className = 'custom-nav-link';

export const NavLink: React.SFC<Props> = props => {
  const close = () => props.toggleDrawer(false);
  return (
    <Container
      className={props.className}
      style={props.margin ? { margin: props.margin } : {}}
    >
      <StyledLink
        onClick={close}
        to={props.to}
        activeClassName={className}
        exact={props.exact}
      >
        {props.children}
      </StyledLink>
    </Container>
  );
};

export const Container = styled.div`
  display: inline-flex;
  align-items: center;
  font-size: 14px;
  margin: 0 50px;
  @media (max-width: 1300px) {
    margin: 0;
  }
`;

const StyledLink = styled(Link)`
  text-decoration: none;
  color: inherit;
  font-weight: 300;
  &.${className} {
    font-weight: 500;
    color: #81d8c3;
  }
`;

export default withRouter(withDrawerState(NavLink));



// WEBPACK FOOTER //
// ./src/components/NavLink/NavLink.tsx